// extracted by mini-css-extract-plugin
module.exports = {"row":"_1KQge98LK9x3aDZq7c6vKd"};